"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var BrowserService = /** @class */ (function () {
    function BrowserService() {
    }
    BrowserService.prototype.isIE = function () {
        var ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
        var msie = ua.indexOf('MSIE '); // IE 10 or older
        var trident = ua.indexOf('Trident/'); // IE 11
        return msie > 0 || trident > 0;
    };
    BrowserService.prototype.isIEOrEdge = function () {
        return !!this.getIEVersion();
    };
    /**
     * Copied from https://github.com/seismic/web-full-bundle-assets/blob/18a798275511b196007ace8d7ab054784e284e85/src/core/utility/common.service.js#L847
     * and removed the assignment of `window.currentBrowser`
     */
    BrowserService.prototype.getIEVersion = function () {
        var version = undefined;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (!version && trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        var edge = ua.indexOf('Edge/');
        if (!version && edge > 0) {
            // IE 12 => return version number
            version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        return version;
    };
    BrowserService = __decorate([
        CommonService_decorator_1.CommonService('BrowserService', { replaceAngularService: 'commonHelper' })
    ], BrowserService);
    return BrowserService;
}());
exports.BrowserService = BrowserService;
//# sourceMappingURL=Browser.service.js.map